canopyPublic.controller("TermsController", ["$scope", function ($scope) {
	var init = function () {
	};
			
	init();
}]);